import * as React from 'react'
import BaseIcon from '../../BaseIcon'

export default class AlertHelp32Icon extends BaseIcon {
  getChildren = () => [
    <path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16 16-7.2 16-16S24.8 0 16 0z" fill="#3b8fd6"/>,
    <circle fill="#fff" cx="16" cy="25.7" r="1.5"/>,
    <path fill="#fff"
          d="M17.2 16.7c-.1 0-.2.1-.2.2v3.3c0 .6-.4 1-1 1s-1-.4-1-1v-3.3c0-1.1.8-2 1.8-2.2 1.9-.3 3.2-2.2 2.8-4.1-.3-1.7-1.9-3-3.6-2.9-1.9 0-3.5 1.6-3.5 3.5 0 .6-.4 1-1 1s-1-.4-1-1c0-3 2.5-5.5 5.5-5.5 3.1 0 5.5 2.5 5.5 5.6 0 2.6-1.8 4.8-4.3 5.4z"/>
          ]
  getViewBox = () => '0 0 32 32'
}
